import { render, staticRenderFns } from "./BookingsList.vue?vue&type=template&id=7d581b18&scoped=true&"
import script from "./BookingsList.vue?vue&type=script&lang=js&"
export * from "./BookingsList.vue?vue&type=script&lang=js&"
import style0 from "./BookingsList.vue?vue&type=style&index=0&id=7d581b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d581b18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VSelect,VTextField,VToolbar})
